"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _mobx = require("mobx");
var _state = require("@seedlang/state");
var _utils = require("@seedlang/utils");
var _lodash = require("lodash");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var VocabWrapper = function VocabWrapper(Component) {
  var _class, _class2, _descriptor, _descriptor2;
  return (0, _mobxReact.observer)(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
    function _class2(props) {
      var _this$props$params;
      var _this;
      _classCallCheck(this, _class2);
      _this = _callSuper(this, _class2, [props]);
      _initializerDefineProperty(_this, "pageIsLoaded", _descriptor, _this);
      _initializerDefineProperty(_this, "initialLoad", _descriptor2, _this);
      _this.onCreateReviews = function () {
        _state.VocabUI.onCreateReviews({
          languageId: _state.AppUI.targetLanguageId
        });
        _state.AppUI.set('reloadReviewDecks', true);
      };
      _state.VocabUI.setPageFromParams((_this$props$params = _this.props.params) === null || _this$props$params === void 0 ? void 0 : _this$props$params.page);
      _this.disposer = (0, _mobx.autorun)(function () {
        if (_state.AppUI.userIsLoaded && !_this.pageIsLoaded) {
          _this.pageIsLoaded = true;
          _state.VocabUI.onSetVocabTab((0, _utils.isPresent)(_state.AppUI.showVocabModal) ? 'trainers' : _state.AppUI.user.vocabTab);
        }
      });
      return _this;
    }
    _inherits(_class2, _React$Component);
    return _createClass(_class2, [{
      key: "componentDidUpdate",
      value: function componentDidUpdate() {
        if ((0, _utils.isPresent)(_state.AppUI.showVocabModal) && _state.VocabUI.vocabTab !== 'trainers') {
          _state.VocabUI.onSetVocabTab('trainers');
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        if (this.constructorDisposer) {
          this.constructorDisposer();
        }
        if (this.disposer) {
          this.disposer();
        }
      }
    }, {
      key: "shouldGetWords",
      get: function get() {
        return !_state.VocabUI.wordStore.hasIndexData || _state.VocabUI.wordStore.page !== _state.VocabUI.page || !(0, _lodash.isEqual)(_state.VocabUI.filters, _state.VocabUI.wordStore.filters);
      }
    }, {
      key: "componentDidMount",
      value: function componentDidMount() {
        var _this2 = this;
        this.disposer = (0, _mobx.autorun)(function () {
          if (!_this2.initialLoad && _state.AppUI.userIsLoaded) {
            _this2.initialLoad = true;
            if (_this2.shouldGetWords) {
              _state.VocabUI.getWords();
            }
          }
          if (_state.AppUI.defaultReviewDeckId && !_state.VocabUI.defaultReviewDeckId) {
            _state.VocabUI.setDefaultReviewDeckId(_state.AppUI.defaultReviewDeckId);
          }
          if (_state.AppUI.vocabWordTypeId) {
            _state.VocabUI.onSetFilter('vocabWordTypeId', _state.AppUI.vocabWordTypeId);
            _state.VocabUI.getWords();
            _state.AppUI.set('vocabWordTypeId', null);
          }
        });
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, this.props, {
          onUpdateSearchQuery: _state.VocabUI.onUpdateSearchQuery,
          wordStore: _state.AppUI.wordStore,
          selectedWordIds: _state.VocabUI.selectedWordIds,
          isMobile: _state.AppUI.layout.isMobile,
          onToggleLearned: _state.VocabUI.onToggleLearned,
          user: _state.AppUI.user,
          searchQuery: _state.VocabUI.searchQuery,
          children: this.props.children,
          deckCreationDisabled: _state.VocabUI.deckCreationDisabled,
          onToggleAddWordToDeck: _state.VocabUI.onToggleAddWordToDeck,
          onToggleAddAllToDeck: _state.VocabUI.onToggleAddAllToDeck,
          counts: _state.AppUI.wordStore.metaData,
          onSetFilter: _state.VocabUI.onSetFilter,
          onCreateReviews: this.onCreateReviews,
          deckIsBeingCreated: _state.VocabUI.deckIsBeingCreated,
          deckButtonDisabled: _state.VocabUI.deckButtonDisabled,
          insertText: _state.VocabUI.insertText,
          caretPosition: _state.VocabUI.caretPosition,
          wordTypesAreAllNoun: _state.VocabUI.wordTypesAreAllNoun,
          allToggleSelected: _state.VocabUI.allToggleSelected,
          afterSubmitSourceInput: _state.VocabUI.afterSubmitSourceInput,
          expandTranslation: _state.VocabUI.expandTranslation,
          onToggleExpandTranslation: _state.VocabUI.onToggleExpandTranslation,
          sort: _state.VocabUI.sort,
          filters: _state.VocabUI.filters,
          sortDirection: _state.VocabUI.sortDirection,
          onClickSort: _state.VocabUI.onClickSort,
          showSource: _state.VocabUI.showSource,
          showNounTrainerButtons: _state.VocabUI.showNounTrainerButtons,
          showAddToReviewsButton: _state.VocabUI.showAddToReviewsButton,
          setWord: _state.VocabUI.setWord,
          showNounButton: _state.VocabUI.showNounButton,
          languagesEnable: _state.VocabUI.languagesEnable,
          languageId: _state.VocabUI.languageId,
          languagesWithWithout: _state.VocabUI.languagesWithWithout,
          showSpinner: _state.VocabUI.showSpinner,
          showWordListSpinner: _state.VocabUI.showWordListSpinner,
          showNoResultsMessage: _state.VocabUI.showNoResultsMessage,
          showColumnCheckbox: _state.VocabUI.showColumnCheckbox,
          decksExpanded: _state.VocabUI.decksExpanded,
          onToggleDecksExpanded: _state.VocabUI.onToggleDecksExpanded,
          filterSettings: _state.VocabUI.filterSettings,
          hasActiveFilter: _state.VocabUI.hasActiveFilter,
          vocabTab: _state.VocabUI.vocabTab,
          onSetVocabTab: _state.VocabUI.onSetVocabTab,
          showVocabModal: _state.AppUI.showVocabModal,
          showTrainersTab: _state.VocabUI.showTrainersTab,
          tabs: _state.VocabUI.tabs,
          pieChartTitle: _state.VocabUI.pieChartTitle,
          pieChartData: _state.VocabUI.pieChartData,
          colors: _state.VocabUI.colors,
          deckId: _state.VocabUI.deckId,
          cardTypeId: _state.VocabUI.cardTypeId,
          reviewDeckOptions: _state.AppUI.reviewDeckOptions,
          cardTypeOptions: _state.VocabUI.cardTypeOptions,
          onSetDeckId: _state.VocabUI.onSetDeckId,
          onSetCardTypeId: _state.VocabUI.onSetCardTypeId,
          filteredItemsCount: _state.VocabUI.filteredItemsCount,
          noFiltersSelectedMessage: _state.VocabUI.noFiltersSelectedMessage,
          setShowFilterOptions: _state.VocabUI.setShowFilterOptions,
          showFilterOptions: _state.VocabUI.showFilterOptions,
          selectedWordsExcludedFromGenderTrainer: _state.VocabUI.selectedWordsExcludedFromGenderTrainer,
          selectedWordsExcludedFromPluralTrainer: _state.VocabUI.selectedWordsExcludedFromPluralTrainer,
          selectedWordsExcludedFromConjugationTrainer: _state.VocabUI.selectedWordsExcludedFromConjugationTrainer,
          createReviewsFinished: _state.VocabUI.createReviewsFinished,
          createReviewsIsSlow: _state.VocabUI.createReviewsIsSlow
        }));
      }
    }]);
  }(_react["default"].Component), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "pageIsLoaded", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "initialLoad", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _applyDecoratedDescriptor(_class2.prototype, "shouldGetWords", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "shouldGetWords"), _class2.prototype), _class2)) || _class;
};
VocabWrapper.displayName = 'VocabWrapper';
var _default = exports["default"] = VocabWrapper;